package com.neurobs.ccabserver.translation.components.phrasetranslation.components

import com.neurobs.react.semanticui.{UiButtonFactory, UiGridFactory, UiLoaderFactory, UiMessageFactory}
import com.neurobs.ccabserver.translation.states.{PhraseTranslationStateGenerator, TranslatorState, TranslatorStateGenerator}
import com.neurobs.react.ReactElementFactory
import slinky.core.FunctionalComponent
import slinky.core.annotations.react
import slinky.core.facade.ReactElement

import scala.scalajs.js

@react
object BackTranslation {
  case class Props(enclosingElement: (ReactElement*) => ReactElement)

  val component = FunctionalComponent[Props] { props =>

    def gridStyle = Seq[(String, js.Any)](("marginBottom", "0px"))

    props.enclosingElement(
      Seq(
        UiGridFactory.Grid(
          BackTranslateButton(
            enclosingElement = UiGridFactory.GridColumn(_)("three wide right aligned")
          ),
          BackTranslationDisplay(
            enclosingElement = UiGridFactory.GridColumn(_)("thirteen wide left aligned")
          )
        )(("middle aligned", gridStyle))
      )
    )

  }
}

@react
object BackTranslateButton {
  case class Props(enclosingElement: (ReactElement*) => ReactElement)
  val component = FunctionalComponent[Props] { props =>

    val translatorState = TranslatorStateGenerator.accessState
    val phraseTranslationState = PhraseTranslationStateGenerator.accessState

    def selectedTranslator = translatorState.selectedTranslator
    def userTranslation = phraseTranslationState.userTranslation

    def handleClick(sourceLanguage: String, userTranslationText: String) =  {
      phraseTranslationState.backTranslate(sourceLanguage, userTranslationText)
    }

    props.enclosingElement(
      Seq[ReactElement](
        selectedTranslator match {
          case None => null
          case Some(translator) =>
            userTranslation match {
              case Left(_) => null
              case Right(translation) =>
                UiButtonFactory.Button("Translate to English", handleClick = () => handleClick(translator.languageDisplayName, translation.text))
            }
        }
      )
    )

  }
}

@react
object BackTranslationDisplay {
  case class Props(enclosingElement: (ReactElement*) => ReactElement)
  val component = FunctionalComponent[Props] { props =>

    val phraseTranslationState = PhraseTranslationStateGenerator.accessState

    def backTranslation = phraseTranslationState.backTranslation
    def awaitingBackTranslation = phraseTranslationState.awaitingBackTranslation

    props.enclosingElement(
      Seq[ReactElement](
        if (awaitingBackTranslation) UiLoaderFactory.ActiveTextLoader("Translating to English...")("mini")
        else backTranslation match {
          case Left(errorOpt) => errorOpt match {
            case None => null
            case Some(_) => UiMessageFactory.BasicErrorMessage("There was an error translating to English")
          }
          case Right(translationResponse) => ReactElementFactory.P(translationResponse.translatedText)(Seq[(String, js.Any)](("fontSize", "16px")))
        }
      )
    )
  }
}
